import { ApiResponse } from "@/types/api-response";
import { ReceiveStockRequest } from "@/types/inventory-ledger-type";
import { apiClient } from "@/api/api-client";
import { endpoints } from "./endpoints/endpoints";

type AdjustInStockRequest = {
  stockId: string;
  quantity: number;
};

type AdjustOutStockRequest = {
  stockId: string;
  quantity: number;
};

export async function createStockReceipt(
  stockReceipt: ReceiveStockRequest
): Promise<ApiResponse<void>> {
  try {
    const response = await apiClient.post(
      endpoints.stock.receive,
      stockReceipt
    );
    return response.data as ApiResponse<void>;
  } catch (error) {
    console.error("Error creating stock receipt:", error);
    throw error;
  }
}

// Bulk receive stock request type - matches backend ReceiveStockRequest
export interface BulkReceiveStockRequest {
  variantId: string; // Long in backend
  quantity: number; // Integer in backend
}
export interface CSVReceiveStockRequest {
  sku: string;
  quantity: number;
}

export async function bulkReceiveStock(
  requests: BulkReceiveStockRequest[]
): Promise<ApiResponse<void>> {
  try {
    const response = await apiClient.post(
      endpoints.stock.bulkReceive,
      requests
    );
    return response.data as ApiResponse<void>;
  } catch (error) {
    console.error("Error bulk receiving stock:", error);
    throw error;
  }
}

export async function csvReceiveStock(input: CSVReceiveStockRequest[]) {
  try {
    const response = await apiClient.post(
      endpoints.stock.csvReceive,
      input
    );
    return response;
  } catch (error) {
    console.error("Error bulk receiving stock:", error);
    throw error;
  }
}

export async function adjustOutStockMovement(
  request: AdjustOutStockRequest
): Promise<ApiResponse<void>> {
  try {
    const response = await apiClient.put(endpoints.stock.adjustOut, request);
    return response.data as ApiResponse<void>;
  } catch (error) {
    console.error("Error adjusting out stock:", error);
    throw error;
  }
}

export async function adjustInStockMovement(
  request: AdjustInStockRequest
): Promise<ApiResponse<void>> {
  try {
    const response = await apiClient.put(endpoints.stock.adjustIn, request);
    return response.data as ApiResponse<void>;
  } catch (error) {
    console.error("Error adjusting in stock:", error);
    throw error;
  }
}
